import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardHostComponent} from './dashboard-host/dashboard-host.component';
import {LinkIndexComponent} from './link/link-index/link-index.component';
import {LinkShowComponent} from './link/link-show/link-show.component';
import {LinkShowResolverService} from './link/link-show/link-show-resolver.service';
import {LinkReportsResolverService} from '../shared/link/link-reports-resolver.service';
import {DashboardHomeComponent} from './dashboard-home/dashboard-home.component';
import {LinkGroupIndexComponent} from './link-group/link-group-index/link-group-index.component';
import {LinkGroupAnalyticsPageComponent} from './link-group/link-group-analytics-page/link-group-analytics-page.component';
import {LinkOverlayIndexComponent} from './link-overlay/link-overlay-index/link-overlay-index.component';
import {TrackingPixelIndexComponent} from './pixels/tracking-pixel-index/tracking-pixel-index.component';
import {CrupdateCustomPageComponent} from '@common/pages/custom-pages-index/crupdate-custom-page/crupdate-custom-page.component';
import {LINK_PAGE_BASE_URI} from './link-page-base-uri';
import {LinkDomainComponent} from './link-domain/link-domain.component';
import {CrupdateLinkOverlayPageComponent} from './link-overlay/link-overlay-index/crupdate-link-overlay-page/crupdate-link-overlay-page.component';
import {LinkGroupLinksIndexComponent} from './link-group/link-groups-links-index/link-group-links-index.component';
import {LinkPageIndexComponent} from './link-page-index/link-page-index.component';
import {PendingChangesGuard} from '@common/guards/pending-changes/pending-changes-guard.service';
import {RedirectToOnboardingGuard} from './dashboard-host/redirect-to-onboarding.guard';
import {WorkspaceIndexComponent} from '@common/workspaces/workspace-index/workspace-index.component';
import {BiolinkIndexComponent} from './biolinks/biolink-index/biolink-index.component';
import { BiolinkEditorComponent } from './biolinks/biolink-editor/biolink-editor.component';

const routes: Routes = [
    {
        path: '',
        component: DashboardHostComponent,
        canActivate: [RedirectToOnboardingGuard],
        children: [
            {
                path: '',
                resolve: {reports: LinkReportsResolverService},
                component: DashboardHomeComponent,
                data: {name: 'Dashboard'},
            },

            // link
            {
                path: 'links',
                component: LinkIndexComponent,
            },
            {
                path: 'links/:linkId',
                resolve: {api: LinkShowResolverService},
                component: LinkShowComponent,
                data: {name: 'Link Statistics'},
            },

            // biolinks
            {
                path: 'biolinks',
                component: BiolinkIndexComponent,
            },
            {
                path: 'biolinks/:linkId/edit',
                component: BiolinkEditorComponent,
                data: {name: 'Edit Bio Link'},
            },
            {
                path: 'biolinks/:biolinkId/analytics',
                component: LinkGroupAnalyticsPageComponent,
                data: {name: 'Biolink Statistics'},
            },

            // group
            {
                path: 'link-groups',
                component: LinkGroupIndexComponent,
            },
            {
                path: 'link-groups/:groupId/links',
                component: LinkGroupLinksIndexComponent,
            },
            {
                path: 'link-groups/:groupId/analytics',
                component: LinkGroupAnalyticsPageComponent,
                data: {name: 'Link Group Statistics'},
            },

            // custom domain
            {
                path: 'custom-domains',
                component: LinkDomainComponent,
                data: {name: 'Custom Domains'},
            },

            // link overlay
            {
                path: 'link-overlays',
                component: LinkOverlayIndexComponent,
                data: {name: 'Link Overlays'},
            },
            {
                path: 'link-overlays/new',
                component: CrupdateLinkOverlayPageComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'link-overlays/edit/:id',
                component: CrupdateLinkOverlayPageComponent,
                canDeactivate: [PendingChangesGuard],
            },

            // tracking pixels
            {
                path: 'pixels',
                component: TrackingPixelIndexComponent,
                data: {name: 'Tracking Pixels'},
            },

            // workspaces
            {
                path: 'workspaces',
                component: WorkspaceIndexComponent,
                data: {name: 'Workspaces'},
            },

            // link pages
            {
                path: 'link-pages',
                component: LinkPageIndexComponent,
                data: {
                    name: 'Link Pages',
                    endpoint: LINK_PAGE_BASE_URI,
                },
            },
            {
                path: 'link-pages/new',
                component: CrupdateCustomPageComponent,
                data: {
                    name: 'Add New Page',
                    hideSlug: true,
                    endpoint: LINK_PAGE_BASE_URI,
                },
            },
            {
                path: 'link-pages/:id/edit',
                component: CrupdateCustomPageComponent,
                data: {
                    name: 'Edit Page',
                    hideSlug: true,
                    endpoint: LINK_PAGE_BASE_URI,
                },
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DashboardRoutingModule {}
